import { all, call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { request } from '../../common/util/RestClient';
import {
  fetchAllEmailCampaigns,
  fetchRecipientsByCampaignId,
  fetchRecipientStatsByCampaignId,
  fetchEngagementMetricsByCampaignId,
  fetchLineGraphMetricsByCampaignId,
  fetchEmailCampaignById,
} from '../routines/emailCampaignRoutine';
import envConfig from '../../config';

const BULK_EMAIL_MGT_URL = `${envConfig.APIG_URL}campaign`;

export function* fetchAllEmailCampaignsSaga() {
  try {
    const response = yield call(request, `${BULK_EMAIL_MGT_URL}`);
    yield put(fetchAllEmailCampaigns.success(response.data));
  } catch (error) {
    yield put(fetchAllEmailCampaigns.failure({ error }));
  } finally {
    yield put(fetchAllEmailCampaigns.fulfill());
  }
}

export function* fetchRecipientsByCampaignIdSaga({ payload }) {
  try {
    const { campaignId, status } = payload;
    const response = yield call(
      request,
      `${BULK_EMAIL_MGT_URL}/${campaignId}/email-recipients?status=${status}`
    );
    yield put(fetchRecipientsByCampaignId.success(response.data));
  } catch (error) {
    yield put(fetchRecipientsByCampaignId.failure({ error }));
  } finally {
    yield put(fetchRecipientsByCampaignId.fulfill());
  }
}

export function* fetchEmailCampaignByIdSaga({ payload }) {
  try {
    const { campaignId } = payload;
    const response = yield call(request, `${BULK_EMAIL_MGT_URL}/${campaignId}`);
    yield put(fetchEmailCampaignById.success(response.data));
  } catch (error) {
    yield put(fetchEmailCampaignById.failure({ error }));
  } finally {
    yield put(fetchEmailCampaignById.fulfill());
  }
}

export function* fetchRecipientStatsByCampaignIdSaga({ payload }) {
  try {
    const { campaignId } = payload;
    const response = yield call(
      request,
      `${BULK_EMAIL_MGT_URL}/${campaignId}/email-recipients/stats`
    );
    yield put(fetchRecipientStatsByCampaignId.success(response.data));
  } catch (error) {
    yield put(fetchRecipientStatsByCampaignId.failure({ error }));
  } finally {
    yield put(fetchRecipientStatsByCampaignId.fulfill());
  }
}

export function* fetchEngagementMetricsByCampaignIdSaga({ payload }) {
  try {
    const { campaignId } = payload;
    const response = yield call(
      request,
      `${BULK_EMAIL_MGT_URL}/${campaignId}/engagement-metrics`
    );
    yield put(fetchEngagementMetricsByCampaignId.success(response.data));
  } catch (error) {
    yield put(fetchEngagementMetricsByCampaignId.failure({ error }));
  } finally {
    yield put(fetchEngagementMetricsByCampaignId.fulfill());
  }
}

export function* fetchLineGraphMetricsByCampaignIdSaga({ payload }) {
  try {
    const { campaignId, type } = payload;
    const response = yield call(
      request,
      `${BULK_EMAIL_MGT_URL}/${campaignId}/engagement-metrics/line-graph?type=${type}`
    );
    yield put(fetchLineGraphMetricsByCampaignId.success(response.data));
  } catch (error) {
    yield put(fetchLineGraphMetricsByCampaignId.failure({ error }));
  } finally {
    yield put(fetchLineGraphMetricsByCampaignId.fulfill());
  }
}

export default function* root() {
  yield all([
    takeLatest(fetchAllEmailCampaigns.TRIGGER, fetchAllEmailCampaignsSaga),
    takeEvery(fetchEmailCampaignById.TRIGGER, fetchEmailCampaignByIdSaga),
    takeEvery(
      fetchRecipientsByCampaignId.TRIGGER,
      fetchRecipientsByCampaignIdSaga
    ),
    takeEvery(
      fetchRecipientStatsByCampaignId.TRIGGER,
      fetchRecipientStatsByCampaignIdSaga
    ),
    takeEvery(
      fetchEngagementMetricsByCampaignId.TRIGGER,
      fetchEngagementMetricsByCampaignIdSaga
    ),
    takeEvery(
      fetchLineGraphMetricsByCampaignId.TRIGGER,
      fetchLineGraphMetricsByCampaignIdSaga
    ),
  ]);
}
